import styles from "../styles";

const DEFAULT_IMAGE_WIDTH = 563;

export default (_text, canvas, windowWidth) => {
  const ctx = canvas.getContext("2d");
  const ratio = canvas.width / DEFAULT_IMAGE_WIDTH;
  const canvasFontSize = `${_text.fontSize * ratio }`;

  ctx.save();
  ctx.font = `${canvasFontSize}px ${_text.fontFamily}`;
  ctx.fillStyle = _text.colour;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  const scaledText = scaleText(
    ctx,
    canvas,
    _text,
    canvasFontSize,
    ratio
  );

  const lineHeight =
    scaledText.lines.length > 1
      ? scaledText.size * styles.text.textValue.lineHeight
      : 0;
  const startingPos = lineHeight * (0.5 * (scaledText.lines.length - 1));

  for (let j = 0, len = scaledText.lines.length; j < len; j++) {
    let adjustWidth = 0;

    if (j === len - 1) {
      adjustWidth =
        (canvas.width * 0.6 - ctx.measureText(scaledText.lines[j][0]).width) /
        (windowWidth / 7);
    }
    // This entire calculation seems wacky. AdjustWidth is like 9px normally - it's pretty
    // unusual. I dunno... :/

    ctx.fillText(
      scaledText.lines[j],
      canvas.width / 2 + scaledText.x + adjustWidth,
      canvas.height / 2 - startingPos + j * lineHeight + scaledText.y
    );
  }

  ctx.restore();
};

const scaleText = (
  ctx,
  canvas,
  text,
  canvasFontSize,
  ratio
) => {
  let lines = [];
  let line = "";

  const textWidth = canvas.width * 0.6;
  const words = text.value.split(" ");

  for (let i = 0, len = words.length; i < len; i++) {
    if (ctx.measureText(words[i]).width > textWidth) {
      lines.push(line); // hummm!
      const wordLines = splitWord(ctx, words[i], textWidth);
      lines =[...lines, ...wordLines];
      line =
        i === words.length - 1 ? "" : `${wordLines[wordLines.length - 1]} `;
      continue;
    }

    if (ctx.measureText(line + words[i]).width > textWidth) {
      lines.push(line);
      line = `${words[i]} `;
      continue;
    }

    line += `${words[i]} `;
  }

  lines.push(line);

  return {
    size: canvasFontSize,
    lines: lines,
    x: text.x * ratio,
    y: text.y * ratio
  };
};

const splitWord = (ctx, word, maxWidth) => {
  const lines = [];
  let line = "";

  for (let i = 0, len = word.length; i < len; i++) {
    if (ctx.measureText(line + word[i]).width > maxWidth) {
      lines.push(line);
      line = word[i];
      continue;
    }

    line += word[i];
  }

  lines.push(line);

  return lines;
};



// WEBPACK FOOTER //
// ./src/actions/generate-text.js